<main>
  <div class="container" id="main-container">
    <div class="row">
      <div class="col px-lg-4">
        <app-breadcrumbs [path]="data?.path?.alias"></app-breadcrumbs>
      </div>
    </div>
    <div class="row" *ngIf="data.moderation_state == 'archived'">
      <div class="col px-lg-4">
        <div class="callout danger">
          <div class="callout-inner">
            <div class="callout-title">
              <svg class="icon">
                <use href="/bootstrap-italia/dist/svg/sprites.svg#it-info-circle"></use>
              </svg>
              <span class="visually-hidden">Note</span>
              <span class="text">Contenuto archiviato</span>
            </div>
            <p><span class="node__archived_text">Contenuto archiviato per fini storici di documentazione.</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 px-lg-4 py-lg-2">
        <h1 data-audio="">
          {{ data.title }}
        </h1>
        <h2 class="visually-hidden">Dettagli della org unit</h2>
        <p data-audio="">
          {{ data.org_unit_short_description }}
        </p>
      </div>

      <div class="col-lg-3 offset-lg-1">
        <app-social-share [url]="data?.path?.alias"></app-social-share>
        <app-actions-list
          [mailObject]="data?.title"
          [path]="data?.path?.alias"
        ></app-actions-list>
        <div class="mt-4 mb-4" *ngIf="data?.org_unit_tags?.length > 0">
          <div class="row">
            <span class="mb-2 small">Argomenti</span>
          </div>
          <ul class="d-flex flex-wrap gap-1">
            <li *ngFor="let tag of data?.org_unit_tags">
              <a class="chip chip-simple" [href]="tag?.path?.alias">
                <span class="chip-label">{{ tag.title }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div
          class="org-unit-type d-flex flex-wrap gap-1"
          *ngIf="data?.org_unit_type?.name"
        >
          <span class="mb-2 small">Tipo unità organizzativa</span>
          <a
            class="chip chip-simple"
            [attr.href]="data?.org_unit_type?.path?.alias || null"
          >
            <span class="chip-label">{{ data.org_unit_type.name }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div
    class="container-fluid my-3"
    *ngIf="data.field_internal_image?.field_media_image"
  >
    <div class="row">
      <figure class="figure px-0 img-full">
        <img
          [src]="data.field_internal_image?.field_media_image?.uri?.url"
          class="figure-img img-fluid"
          [alt]="data.field_internal_image?.field_media_image?.meta?.alt"
        />
        <figcaption class="figure-caption text-center pt-3">
          {{ data.field_internal_image?.field_media_image?.meta?.title }}
          <span *ngIf="data?.field_internal_image?.field_media_licence">
            - {{ data.field_internal_image?.field_media_licence }}</span
          >
        </figcaption>
      </figure>
    </div>
  </div>
  <div class="container">
    <div
      class="row border-top border-light row-column-border row-column-menu-left"
    >
      <aside class="col-lg-3">
        <div
          class="cmp-navscroll sticky-top"
          aria-labelledby="accordion-title-one"
        >
          <nav
            class="navbar it-navscroll-wrapper navbar-expand-lg"
            aria-label="INDICE DELLA PAGINA"
            data-bs-navscroll=""
          >
            <div class="navbar-custom" id="navbarNavProgress">
              <div class="menu-wrapper">
                <div class="link-list-wrapper">
                  <div class="accordion">
                    <div class="accordion-item">
                      <span class="accordion-header" id="accordion-title-one">
                        <button
                          class="accordion-button pb-10 px-3"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse-one"
                          aria-expanded="true"
                          aria-controls="collapse-one"
                        >
                          INDICE DELLA PAGINA
                          <svg class="icon icon-xs right">
                            <use
                              href="bootstrap-italia/dist/svg/sprites.svg#it-expand"
                            ></use>
                          </svg>
                        </button>
                      </span>
                      <div class="progress">
                        <div
                          class="progress-bar it-navscroll-progressbar"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style="width: 0%"
                        ></div>
                      </div>
                      <div
                        id="collapse-one"
                        class="accordion-collapse collapse show"
                        role="region"
                        aria-labelledby="accordion-title-one"
                      >
                        <div class="accordion-body">
                          <ul class="link-list" data-element="page-index">
                            <li
                              class="nav-item"
                              *ngIf="data.org_unit_competences?.processed"
                            >
                              <a
                                class="nav-link"
                                href="javascript:void(0);"
                                data-focus-mouse="false"
                                (click)="scrollTo('competenze')"
                              >
                                <span class="title-medium">Competenze</span>
                              </a>
                            </li>
                            <li class="nav-item">
                              <a
                                class="nav-link"
                                href="javascript:void(0);"
                                data-focus-mouse="false"
                                (click)="scrollTo('tipo-unita')"
                              >
                                <span class="title-medium"
                                  >Tipo unità organizzativa</span
                                >
                              </a>
                            </li>
                            <li
                              class="nav-item"
                              *ngIf="data.org_unit_public_person.length > 0"
                            >
                              <a
                                class="nav-link"
                                href="javascript:void(0);"
                                data-focus-mouse="false"
                                (click)="scrollTo('persone')"
                              >
                                <span class="title-medium">
                                  {{
                                    data.org_unit_public_person.length > 1
                                      ? "Persone"
                                      : "Persona"
                                  }}</span
                                >
                              </a>
                            </li>
                            <li
                              class="nav-item"
                              *ngIf="data.org_unit_headquarters.length > 0"
                            >
                              <a
                                class="nav-link"
                                href="javascript:void(0);"
                                data-focus-mouse="false"
                                (click)="scrollTo('sede-principale')"
                              >
                                <span class="title-medium">
                                  {{
                                    data.org_unit_headquarters.length > 1
                                      ? "Sedi principali"
                                      : "Sede principale"
                                  }}</span
                                >
                              </a>
                            </li>
                            <li
                              class="nav-item"
                              *ngIf="data.org_unit_contacts.length > 0"
                            >
                              <a
                                class="nav-link"
                                href="javascript:void(0);"
                                (click)="scrollTo('contatti')"
                                data-focus-mouse="false"
                              >
                                <span class="title-medium">Contatti</span>
                              </a>
                            </li>
                            <ng-container *ngFor="let link of links">
                              <li class="nav-item">
                                <a
                                  class="nav-link"
                                  href="javascript:void(0);"
                                  data-focus-mouse="false"
                                  (click)="scrollTo(link.url)"
                                >
                                  <span class="title-medium">{{
                                    link.title
                                  }}</span>
                                </a>
                              </li>
                            </ng-container>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </aside>
      <section class="col-lg-9 it-page-sections-container border-light">
        <article
          id="competenze"
          class="it-page-section anchor-offset richtext-wrapper"
        >
          <h2 class="mb-3" *ngIf="data.org_unit_competences?.processed">
            Competenze
          </h2>
          <p [innerHTML]="data.org_unit_competences?.processed"></p>
        </article>

        <article
          id="persone"
          class="it-page-section anchor-offset richtext-wrapper"
          *ngIf="data.org_unit_public_person.length > 0"
        >
          <h2 class="mb-3">
            {{ data.org_unit_public_person.length > 1 ? "Persone" : "Persona" }}
          </h2>
          <div class="card-wrapper card-teaser-wrapper">
            <div
              class="card card-teaser shadow-sm mt-3 rounded align-items-center"
              *ngFor="let person of data?.org_unit_public_person"
            >
              <div class="card-body pe-3">
                <h3 class="card-title h5">
                  <a [href]="person.path.alias" class="text-decoration-none">
                    {{ person.title }}
                  </a>
                </h3>
                <div
                  class="card-text mt-0"
                  *ngFor="let role of person.person_roles"
                >
                  <p>{{ role.title }}</p>
                </div>
              </div>
              <ng-container
                *ngIf="
                  person.field_internal_image?.field_media_image?.uri?.url;
                  then useImage
                "
              ></ng-container>
              <ng-template #useImage>
                <div class="avatar size-xl">
                  <img
                    [src]="
                      person.field_internal_image?.field_media_image?.uri?.url
                    "
                    [alt]="
                      person.field_internal_image?.field_media_image?.meta?.alt
                    "
                  />
                </div>
              </ng-template>
              <!-- <ng-template #useStandardIcon>
                <div class="avatar bg-white size-xl">
                  <svg class="icon" aria-hidden="true">
                    <use href="bootstrap-italia/dist/svg/sprites.svg#it-user"></use>
                  </svg>
                </div>
              </ng-template> -->
            </div>
          </div>
        </article>
        <article
          id="sede-principale"
          class="it-page-section anchor-offset richtext-wrapper"
          *ngIf="data.org_unit_headquarters.length > 0"
        >
          <h2 class="mb-3">
            {{
              data.org_unit_headquarters.length > 1
                ? "Sedi principali"
                : "Sede principale"
            }}
          </h2>
          <div class="card-wrapper card-teaser-wrapper">
            <div
              class="card card-teaser card-teaser-info shadow-sm mt-3 rounded"
              *ngFor="let headquarter of data?.org_unit_headquarters"
            >
              <div class="card-body">
                <h3 class="card-title h5">
                  <a
                    [href]="headquarter?.path?.alias"
                    class="text-decoration-none"
                  >
                    {{ headquarter?.title }}
                  </a>
                </h3>
                <div class="card-text">
                  <p>
                    {{ headquarter?.place_address }},
                    {{ headquarter?.place_cap }}
                  </p>
                </div>
              </div>
              <ng-container
                *ngIf="
                  headquarter?.place_image?.field_media_image?.uri?.url;
                  then useImage;
                  else useStandardIcon
                "
              ></ng-container>
              <ng-template #useImage>
                <div class="avatar size-xl">
                  <img
                    [src]="
                      headquarter?.place_image?.field_media_image?.uri?.url
                    "
                    [alt]="
                      headquarter?.place_image?.field_media_image?.meta?.alt
                    "
                  />
                </div>
              </ng-template>
              <ng-template #useStandardIcon>
                <div class="avatar bg-white size-xl">
                  <svg class="icon" aria-hidden="true">
                    <use
                      href="bootstrap-italia/dist/svg/sprites.svg#it-pin"
                    ></use>
                  </svg>
                </div>
              </ng-template>
            </div>
          </div>
        </article>
        <ng-container *ngIf="data.org_unit_contacts.length > 0">
          <app-contacts [data]="data.org_unit_contacts"></app-contacts>
        </ng-container>
      </section>
    </div>
  </div>
</main>
